module.exports = __webpack_public_path__ + "static/7-40521b72fcca876497e47de30e9fd234.jpg";